import React from 'react';
import { PasswordChangeTemplate } from 'themes/modules/membership/pages';
import { setCurrentView } from 'core/utils';
import { PasswordChangeViewStore } from 'modules/membership/stores';

@setCurrentView(rootStore => new PasswordChangeViewStore(rootStore), 'passwordChangeViewStore')
class PasswordChange extends React.Component {
	render() {
		return <PasswordChangeTemplate {...this.props} viewStore={this.props.passwordChangeViewStore} />;
	}
}

export default PasswordChange;



// WEBPACK FOOTER //
// ./src/modules/membership/pages/PasswordChange.jsx